import React, { useState, useEffect } from "react";
import {
  ModalBackdrop,
  ModalCard,
  ModalAccent,
  ModalBody,
  ModalHeader,
  ModalHeaderContent,
  ModalCancelBtn,
  ModalCloseBtn,
  ModalTitle,
  ModalSubtitle,
  ModalFooter,
  FieldGroup,
  FieldLabel,
  FieldError,
  BundleCheckItem,
  BundleCheckList,
  FieldInput,
  ModalCreateBtn,
  G,
  IcoX,
} from "./styles";
import { COLORS } from "./tokens";
import styled from "styled-components";
import theme from "../../../../assets/theme";

const CombineBundleModal = ({
  open,
  onClose,
  bundles,
  onCombined,
  ownerId,
}) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [newBundleName, setNewBundleName] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      setSelectedIds([]);
      setNewBundleName("");
      setError("");
      setSubmitting(false);
    }
  }, [open]);

  if (!open) return null;

  const toggle = (id) =>
    setSelectedIds((p) =>
      p.includes(id) ? p.filter((x) => x !== id) : [...p, id],
    );

  const handleCombine = async () => {
    if (selectedIds.length < 2) {
      setError("Select at least 2 bundles to combine.");
      return;
    }
    if (!newBundleName.trim()) {
      setError("New bundle name is required.");
      return;
    }
    setSubmitting(true);

    try {
      await onCombined({
        bundleIds: selectedIds,
        name: newBundleName.trim(),
        bundleCode: "B" + Math.floor(100 + Math.random() * 900),
      });
      onClose();
    } catch (err) {
      setError(err?.message || "Failed to combine bundles.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ModalBackdrop onClick={onClose}>
      <ModalCard onClick={(e) => e.stopPropagation()} style={{ maxWidth: 540 }}>
        <ModalHeader>
          <ModalAccent style={{ background: "#00838c" }} />
          <ModalHeaderContent>
            <ModalTitle>Combine Bundles</ModalTitle>
            <ModalSubtitle>
              Select 2 or more bundles to merge. Their sub-folders and page
              assignments will be combined into a new bundle.
            </ModalSubtitle>
          </ModalHeaderContent>
          <ModalCloseBtn onClick={onClose}>
            <IcoX size={14} color={G.slate500} />
          </ModalCloseBtn>
        </ModalHeader>
        <ModalBody>
          <FieldGroup>
            <FieldLabel>SELECT BUNDLES TO COMBINE</FieldLabel>
            <BundleCheckList>
              {bundles.map((b) => (
                <BundleCheckItem
                  key={b.id}
                  $selected={selectedIds.includes(b.id)}
                  onClick={() => toggle(b.id)}
                >
                  <BundleIdChip style={{ fontSize: 10, color: G.slate400 }}>
                    {b.bundleCode || b.id}
                  </BundleIdChip>
                  <span style={{ fontSize: 12.5, color: COLORS.COLOR_DARK }}>
                    {b.name}
                  </span>
                  <span
                    style={{
                      marginLeft: "auto",
                      fontSize: 11,
                      color: G.slate400,
                    }}
                  >
                    {(b.bundles || []).length} sub-folder
                    {(b.bundles || []).length !== 1 ? "s" : ""}
                  </span>
                </BundleCheckItem>
              ))}
            </BundleCheckList>
          </FieldGroup>
          <FieldGroup>
            <FieldLabel>
              NEW BUNDLE NAME <span className="required-star">*</span>
            </FieldLabel>
            <FieldInput
              placeholder="e.g. Combined Witness Bundle"
              value={newBundleName}
              onChange={(e) => {
                setNewBundleName(e.target.value);
                setError("");
              }}
            />
          </FieldGroup>
          {error && <FieldError>{error}</FieldError>}
        </ModalBody>
        <ModalFooter>
          <ModalCancelBtn onClick={onClose}>Cancel</ModalCancelBtn>
          <ModalCreateBtn
            onClick={handleCombine}
            disabled={submitting}
            style={{
              background: "#00838c",
              color: "#FFFFFF",
              opacity: submitting ? 0.7 : 1,
            }}
          >
            Submit
          </ModalCreateBtn>
        </ModalFooter>
      </ModalCard>
    </ModalBackdrop>
  );
};

export default CombineBundleModal;

const BundleIdChip = styled.span`
  font-size: 11.5px;
  font-weight: 700;
  color: ${G.teal};
  background: ${G.tealLight};
  border: 1px solid ${G.tealMid};
  padding: 3px 9px;
  border-radius: 5px;
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
